











import StatusImg from '@/components/image/StatusImg.vue'
import {Component, Vue, Prop} from 'vue-property-decorator'

@Component({
  components: {
    StatusImg,
  },
})
export default class EmptyMessage extends Vue {
  @Prop({default: ''}) message: string[]
  @Prop({default: 'empty'}) status: string
}
